<lhc-item-question-text [item]="item"></lhc-item-question-text>
